import React from 'react';
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Link } from './ui/Link';

const extranetLink = 'https://extranet.advieskeuze.nl'

const BlogSideCards: React.FC = () => (
    <div>
      <div className="bg-stone-50 text-center w-full px-5 py-10 rounded-[12px] margin-0 auto">
        <h2 className="text-blue-700 font-avantgarde text-xl font-bold">
          Inhoudelijke vraag stellen?
        </h2>
        <div className="text-stone-800 text-sm mt-3">
          Bekijk ook ons expertplatform waar je inhoudelijke vragen kan stellen
          aan de aangesloten dienstverleners op Advieskeuze.
        </div>
        <div className="w-full flex justify-center mt-[10px]">
          <Link
            variant="primary"
            href="/expert"
            className="w-full md:w-fit md:text-sm font-bold"
          >
            Expertplatform
            <FontAwesomeIcon icon={faChevronRight as IconProp} />
          </Link>
        </div>
      </div>
      <div className="border border-solid border-blue-200 text-center w-full px-5 py-10 rounded-[12px] margin-0 auto mt-3 mb-5">
        <h2 className="text-blue-700 font-avantgarde text-xl font-bold">
          Schrijf je eigen blog in het extranet van Advieskeuze.nl.
        </h2>
        <div className="w-full flex justify-center mt-[10px]">
          <Link
            variant="primary"
            href={extranetLink}
            className="w-full md:w-fit md:text-sm font-bold"
          >
            Extranet
            <FontAwesomeIcon icon={faChevronRight as IconProp} />
          </Link>
        </div>
      </div>
    </div>
  );

export default BlogSideCards;
